import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useEditorState } from "@tiptap/react";
import { Header, LockedBanner, RichTextEditor } from "./components";
import styles from "./RichTextEditorContainer.module.css";

const RichTextEditorContainer = ({ debouncedUpdateNote, editor, noteStatus, onSetNoteStatus }) => {
	const selectedNote = useSelector(({ note }) => note.selectedNote);
	const [forceNoteCreation, setForceNoteCreation] = useState(false);
	const editorState = useEditorState({
		editor,
		selector: (ctx) => ({
			isBold: ctx.editor.isActive("bold") ?? false,
			canBold: ctx.editor.can().chain().toggleBold().run() ?? false,
			isItalic: ctx.editor.isActive("italic") ?? false,
			canItalic: ctx.editor.can().chain().toggleItalic().run() ?? false,
			isStrike: ctx.editor.isActive("strike") ?? false,
			canStrike: ctx.editor.can().chain().toggleStrike().run() ?? false,
			isUnderline: ctx.editor.isActive("underline") ?? false,
			isHeading: ctx.editor.getAttributes("heading"),
			canUnderline: ctx.editor.can().chain().toggleUnderline().run() ?? false,
			isBulletList: ctx.editor.isActive("bulletList") ?? false,
			isOrderedList: ctx.editor.isActive("orderedList") ?? false,
			canUndo: ctx.editor.can().chain().focus().undo().run() ?? false,
			canRedo: ctx.editor.can().chain().focus().redo().run() ?? false,
		}),
	});
	const handleCancelForceNoteCreation = () => {
		setForceNoteCreation(false);
	};
	return (
		<div className={styles.container}>
			{!editor.isEditable && selectedNote.id && <LockedBanner noteStatus={noteStatus} />}
			<Header
				debouncedUpdateNote={debouncedUpdateNote}
				editor={editor}
				editorState={editorState}
				forceNoteCreation={forceNoteCreation}
				onCancelForceNoteCreation={handleCancelForceNoteCreation}
				onSetNoteStatus={onSetNoteStatus}
			/>
			<RichTextEditor
				editor={editor}
				editorState={editorState}
				forceNoteCreation={forceNoteCreation}
				onCancelForceNoteCreation={handleCancelForceNoteCreation}
				onSetNoteStatus={onSetNoteStatus}
			/>
		</div>
	);
};

export default RichTextEditorContainer;
